<template>
	<div class="wrapper">
		<header-comp ref="header"></header-comp>
		<main ref="main">
			<home-comp v-if="home" ref="home"></home-comp>
			<about-comp v-if="about" ref="about"></about-comp>
		</main>
        <loader-comp></loader-comp>
	</div>
</template>

<script>
import HeaderComp from '@/components/Header'
import AboutComp from '@/components/About'
import HomeComp from '@/components/Home'
import LoaderComp from '@/components/Loader'
export default {
	data() {
		return {
			home: this.$route.name === 'index',
			about: this.$route.name === 'about'
		}
	},
	computed: {
		loaderIsHidden: function() {
			return this.$store.getters['ui/loaderIsHidden']
		},
		blockedOverflow: function() {
			return this.$store.getters['ui/blockedOverflow']
		}
	},
	watch: {
        '$route': function(to, from) {
			this.checkForRoute(to, from)
		},
		'blockedOverflow': function(blocked) {
			this.toggleLock(blocked)
		}
	},
	mounted() {
		this.toggleLock(true)
		this.checkForRoute(this.$route)
    },
	methods: {
		checkForRoute(to, from = {name: null}, next = () => {}) {
			if (this.loaderIsHidden) {
				this.routePages(to, from)
			} else {
				const unwatch = this.$watch('loaderIsHidden', loaderIsHidden => {
					unwatch()
					if (loaderIsHidden) {
						this.routePages(to, from, next)
					}
				})
			}
		},
		toggleLock(locked = false) {
			if (locked) {
				document.addEventListener("touchmove", this.touchMovePreventDefault, { passive: false });
				document.documentElement.classList.add('locked')
			} else {
				document.removeEventListener("touchmove", this.touchMovePreventDefault, { passive: false });
				document.documentElement.classList.remove('locked')
			}
		},
		touchMovePreventDefault(event) {
			if (event) {
				event.preventDefault()
				event.stopPropagation()
			}
		},
		openHome(to, from) {
			this.home = true
			return this.$refs.home.showTimeline()
		},
		openAbout(to, from) {
			this.home = false
			this.about = true
			this.$nextTick(() => {
				const tl = new TimelineMax({paused: true})
				tl.add(this.$refs.about.showTimeline())
				tl.play()
			})
		},
		routePages(to, from, next) {
			if (to.name === 'index') {
				if (from.name === 'about') {
					this.home = true
					this.$nextTick(() => {
						const tl = new TimelineMax({
							paused: true
						})
						tl
						.set(this.$refs.home.$el, {
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							zIndex: 3
						})
						.add(this.$refs.about.closingWave())
						.set(this.$refs.home.$el, {
							clearProps: 'all'
						})
						.add(() => {
							this.openHome(to, from)
						}, '-=' + this.$refs.about.closingWave().duration() * 0.6)
						.add(() => {
							this.about = false
						})
						tl.play()
					})
				} else {
					this.openHome(to, from)
				}
			} else if (to.name === 'about') {
				if (from.name !== null) {
					this.about = true
					this.$nextTick(() => {
						const tl = new TimelineMax({
							paused: true,
							overwrite: 'all'
						})
						tl.set(this.$refs.about.$el, {
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							zIndex: 4
						})
						.add(this.$refs.home.openAbout())
						.add(this.$refs.about.openningWave(), 0)
						.add(() => {
							this.openAbout(to, from)
						}, '-=' + this.$refs.about.openningWave().duration() * 0.6)
						.set(this.$refs.about.$el, {
							clearProps: 'all'
						})
						tl.play()
					})
				} else {
					const tl = new TimelineMax({
						onComplete: () => {
							this.openAbout(to, from)
						}
					})
					tl
					.add(this.$refs.about.openningWave(0))
					.fromTo(this.$refs.about.$el, 0.7, {
						y: '30vh',
						opacity: 0
					}, {
						y: 0,
						opacity: 1,
						ease: Power4.easeOut,
						onComplete: () => {
							TweenMax
							.set(this.$refs.about.$el, {
								clearProps: 'all'
							})
						}
					})
				}
			}
		}
	},
	components: {
		HeaderComp,
		HomeComp,
		AboutComp,
		LoaderComp
	}
}
</script>
<style lang="sass">
.wrapper
	main
		flex-grow: 1
		position: relative
		[data-image-animated=false]
			opacity: 0
			transform: translateY(10%)
		[data-text-animated] text-line
			opacity: 0
			transform: translateY(140%)
		[data-image-animated=true]
			transition: all 1.1s var(--ease)
			opacity: 1
			transform: none
</style>



// WEBPACK FOOTER //
// src/components/Index.vue